<template>
    <main id="js-page-content" class="perf-v2" role="main" v-if='loading'>
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('post.page.choiceviewlistposts.performanceview') }}</div>
        </portal>

        <header class="perf-hero">
            <div class="perf-hero-text">
                <h1 class="perf-hero-title">{{ $t('post.page.choiceviewlistposts.performanceview') }}</h1>
                <p class="perf-hero-sub">
                    {{ $t('post.page.performances.subtitle') || 'Temps de réponse, volumes et délais de traitement.' }}
                </p>
            </div>
            <MultipleListCreate class="perf-multi-list" />
        </header>

        <div class="perf-stats" v-if="endpointStatistics">
            <div v-if="endpointStatistics.totalMessages !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(8, 145, 178, 0.1);">
                    <i class="fal fa-comments" style="color: #0891B2;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.totalMessages || 0 }}</span>
                    <span class="perf-card-label">{{ $t('post.page.performances.answers_total') }}</span>
                </div>
            </div>

            <div v-if="endpointStatistics.totalPostWithMessage !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(16, 185, 129, 0.1);">
                    <i class="fal fa-ticket" style="color: #10b981;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.totalPostWithMessage || 0 }}</span>
                    <span class="perf-card-label">{{ $t('post.page.performances.answers_total_tickets') }}</span>
                </div>
            </div>

            <div v-if="endpointStatistics.totalFinishedPostsWithoutAnswer !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(245, 158, 11, 0.1);">
                    <i class="fal fa-check-circle" style="color: #f59e0b;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.totalFinishedPostsWithoutAnswer }}</span>
                    <span class="perf-card-label">{{ $t('post.page.performances.no_answer_total_tickets') }}</span>
                </div>
            </div>

            <div v-if="endpointStatistics.averageResponseTime !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(139, 92, 246, 0.1);">
                    <i class="fal fa-clock" style="color: #8b5cf6;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.averageResponseTime }}</span>
                    <span class="perf-card-label">
                        {{ $t('post.page.performances.answers_average_by_ticket') }}
                        <small class="perf-card-hint">{{ $t('post.page.performances.at_least_one_answer') }}</small>
                    </span>
                </div>
            </div>

            <div v-if="endpointStatistics.averageMessagePerPost !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(59, 130, 246, 0.1);">
                    <i class="fal fa-chart-line" style="color: #3b82f6;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.averageMessagePerPost }}</span>
                    <span class="perf-card-label">{{ $t('post.page.performances.answers_average_required') }}</span>
                </div>
            </div>

            <div v-if="endpointStatistics.averageMessagePerPostFinished !== undefined" class="perf-card">
                <div class="perf-card-icon" style="background: rgba(239, 68, 68, 0.1);">
                    <i class="fal fa-flag-checkered" style="color: #ef4444;"></i>
                </div>
                <div class="perf-card-info">
                    <span class="perf-card-value">{{ endpointStatistics.averageMessagePerPostFinished }}</span>
                    <span class="perf-card-label">
                        {{ $t('post.page.performances.answers_average_required') }}
                        <small class="perf-card-hint">{{ $t('post.page.performances.at_least_one_answer') }}</small>
                    </span>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
// import Panel from '../../components/UI/Panel'
import { mapActions, mapState } from 'vuex'
import MultipleListCreate from '@/components/UI/MultipleListCreate'
// import IconNotification from '@/components/icons/iconNotification.vue'

export default {
    name: 'Performances',
    components: {
        // Panel,
        MultipleListCreate,
        // IconNotification,
    },
    data() {
        return {
          loading : false,
            endpointStatistics: null
        }
    },
    computed: {
        ...mapState('post', {
            config: (state) => state.postsConfig
            // statistics: (state) => state.statistics,
        })
    },
    created() {
      this.loading = false;
        this.getPerformance()
            .then((value) => {
              this.loading = true;
                this.endpointStatistics = value.data
            })
            .catch(() => {})
    },
    methods: {
        ...mapActions('post', ['getPerformance'])
    }
}
</script>

<style scoped>
.perf-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.perf-hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
}

.perf-hero-text {
    min-width: 0;
}

.perf-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.perf-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.perf-multi-list {
    flex-shrink: 0;
}

.perf-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: var(--v2-space-3);
    margin-bottom: var(--v2-space-4);
}

.perf-card {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
    padding: var(--v2-space-4) var(--v2-space-5);
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    transition: border-color var(--v2-transition-fast), box-shadow var(--v2-transition-fast);
}

.perf-card:hover {
    border-color: var(--v2-primary);
    box-shadow: var(--v2-shadow-sm);
}

.perf-card-icon {
    width: 40px;
    height: 40px;
    border-radius: var(--v2-radius-md);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.perf-card-icon i {
    font-size: 1rem;
}

.perf-card-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 4px;
}

.perf-card-value {
    font-size: 1.5rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    line-height: 1;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
}

.perf-card-label {
    font-size: var(--v2-text-xs-size);
    color: var(--v2-text-3);
    line-height: 1.3;
}

.perf-card-hint {
    display: block;
    font-size: 0.68rem;
    color: var(--v2-text-4);
    margin-top: 2px;
}

@media (max-width: 900px) {
    .perf-v2 {
        padding: 16px 18px 32px;
    }

    .perf-hero {
        flex-direction: column;
        align-items: stretch;
        gap: var(--v2-space-3);
    }

    .perf-hero-title {
        font-size: 1.375rem;
    }

    .perf-card {
        padding: var(--v2-space-3) var(--v2-space-4);
    }
}
</style>
